import { FC, PropsWithChildren } from 'react';
import { ListItem, ListItemIcon, ListItemProps, Typography } from '@mui/material';
import { FontWeights } from 'theme/Typography';
import { COLOR_BLACK, COLOR_LIGHT_GRAY } from 'theme/variables';

type CustomListItemProps = {
  sequenceNumber: number;
  text: string;
};

export const CustomListItem: FC<ListItemProps & PropsWithChildren<CustomListItemProps>> = ({
  children,
  sequenceNumber,
  text,
  ...fieldProps
}) => {
  return (
    <ListItem sx={{ alignItems: 'start', flexDirection: 'column', gap: '20px' }} {...fieldProps}>
      <ListItemIcon sx={{ minWidth: 'unset', alignItems: 'center', gap: '10px' }}>
        <Typography
          sx={{
            fontSize: '20px',
            lineHeight: '1.2em',
            background: COLOR_LIGHT_GRAY,
            borderRadius: '50%',
            fontWeight: FontWeights.fontWeightBold,
            width: '30px',
            height: '30px',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: `${COLOR_BLACK} !important`,
            fontFamily: '"Roboto-Mono", sans-serif !important',
          }}
        >
          {sequenceNumber}
        </Typography>
        <Typography
          sx={{
            fontWeight: FontWeights.fontWeightLight,
            fontSize: '16px',
            lineHeight: '100%',
          }}
        >
          {text}
        </Typography>
      </ListItemIcon>
      {children}
    </ListItem>
  );
};
